import { getPreviewHtml } from "components/Preview/Functions";
import { getPageProperties } from "functions";
import React, { useMemo } from "react";
import { connect, ConnectedProps } from "react-redux";
import { RootState } from "us.helper/types";
import { DocumentType } from "constants/TemplateEditor";
import { useTranslation } from "react-i18next";

type BasicPreviewProps = {
  pageIndex: number;
  defaultOptions: any;
};

const BasicPreview: React.FC<PropsFromRedux & BasicPreviewProps> = ({
  pageIndex,
  template,
  defaultOptions,
  previewData,
}) => {
  const { t } = useTranslation();

  const pageProperties = useMemo(() => {
    return getPageProperties(template.data?.outPutFormat as DocumentType);
  }, [template.data?.outPutFormat]);

  return (
    <div>
      {template.loading && (
        <span className="page-loading">{t("COMMON.LOADING")}...</span>
      )}
      <div
        className="preview-page"
        id={`prev_page_${pageIndex}`}
        key={pageIndex.toString()}
        style={{
          height: pageProperties.height,
        }}
      >
        <>{getPreviewHtml(pageIndex, defaultOptions, previewData.data)}</>
      </div>
    </div>
  );
};

const mapStateToProps = (state: RootState) => {
  const { templateEditor, templatesHistory } = state;
  const { previewData } = templateEditor;
  const { template } = templatesHistory;

  return {
    template,
    previewData,
  };
};

const mapDispatchToProps = {};

const connector = connect(mapStateToProps, mapDispatchToProps);

type PropsFromRedux = ConnectedProps<typeof connector>;

export default connector(BasicPreview);
